import { color } from '@ticketswap/solar'
import NProgress from 'nprogress'
import Router from 'next/router'
import { Global, css } from '@emotion/react'

let timeout

const start = () => {
  timeout = setTimeout(NProgress.start, 100)
}

const done = () => {
  clearTimeout(timeout)
  NProgress.done()
}

NProgress.configure({ showSpinner: false })
Router.events.on('routeChangeStart', start)
Router.events.on('routeChangeComplete', done)
Router.events.on('routeChangeError', done)

const ProgressBar = () => (
  <Global
    styles={css`
      /* Make clicks pass-through */
      #nprogress {
        pointer-events: none;
      }

      #nprogress .bar {
        background: ${color.earth};
        position: fixed;
        z-index: 2147483647;
        inset-block-start: 0;
        inset-inline-start: 0;
        width: 100%;
        height: 3px;
      }

      /* Fancy blur effect */
      #nprogress .peg {
        display: block;
        position: absolute;
        inset-inline-end: 0px;
        width: 100px;
        height: 100%;
        box-shadow: 0 0 10px ${color.earth}, 0 0 5px ${color.earth};
        opacity: 1;
        transform: rotate(3deg) translate(0px, -4px);
      }
    `}
  />
)

export default ProgressBar
